import { styled } from '@linaria/react';

const QuoteIcon = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  &::after {
    content: '“';
    position: absolute;
    left: 0;
    top: 0;
    font-family: 'Times New Roman', serif;
    font-size: 4.5rem;
    line-height: 2.5rem;
    font-weight: bold;
    transform: translateX(-50%);
    color: var(--color-info-400);
  }
`;

export default QuoteIcon;
